// Era configuration for the timeline theming system
// Add new eras by adding a new object following this schema

export const eras = {
  modern: {
    id: 'modern',
    label: 'Modern',
    year: '2020s',
    description: 'Clean, minimal design',
    cssVariables: {
      '--era-bg-primary': '#0e1729',
      '--era-bg-secondary': '#182848',
      '--era-text-primary': '#d0daee',
      '--era-text-muted': '#8892a6',
      '--era-accent': '#59dcd5',
      '--era-accent-bg': 'rgba(74, 201, 110, 0.1)',
      '--era-link-color': '#59dcd5',
      '--era-font-heading': "'Prata', serif",
      '--era-font-body': "'Inter', -apple-system, sans-serif",
      '--era-border-radius': '15px',
      '--era-card-bg': 'rgba(205, 205, 205, 0.05)',
      '--era-card-bg-hover': 'rgba(205, 205, 205, 0.08)',
      '--era-section-bar': 'rgba(208, 218, 238, 0.75)',
      '--era-section-bar-active': '#d0daee',
      '--era-transition': '250ms ease-in-out',
    },
    features: {
      marquee: false,
      hitCounter: false,
      blinkingText: false,
      underConstruction: false,
      tiledBackground: false,
      cursorTrail: false,
      guestbook: false,
    },
  },
  '2000s': {
    id: '2000s',
    label: 'Y2K',
    year: '2000s',
    description: 'Web 1.0 Maximalist',
    cssVariables: {
      '--era-bg-primary': '#000080',
      '--era-bg-secondary': '#0000AA',
      '--era-text-primary': '#FFFF00',
      '--era-text-muted': '#00FFFF',
      '--era-accent': '#FF00FF',
      '--era-accent-bg': 'rgba(255, 0, 255, 0.2)',
      '--era-link-color': '#00FF00',
      '--era-font-heading': "'Comic Sans MS', 'Comic Sans', cursive",
      '--era-font-body': "'Comic Sans MS', 'Comic Sans', cursive",
      '--era-border-radius': '0px',
      '--era-card-bg': 'rgba(0, 0, 0, 0.5)',
      '--era-card-bg-hover': 'rgba(0, 0, 0, 0.7)',
      '--era-section-bar': '#00FFFF',
      '--era-section-bar-active': '#FFFF00',
      '--era-transition': '0ms',
    },
    features: {
      marquee: true,
      hitCounter: true,
      blinkingText: true,
      underConstruction: true,
      tiledBackground: true,
      cursorTrail: false,
      guestbook: false,
    },
    text: {
      welcomeMarquee: "Welcome to Caleb's AWESOME Homepage!!! You are visitor #",
      underConstructionText: 'This site is UNDER CONSTRUCTION!!!',
    },
  },
  '80s': {
    id: '80s',
    label: 'Terminal',
    year: '1980s',
    description: 'DOS/Early Computing Terminal',
    cssVariables: {
      '--era-bg-primary': '#0a0a0a',
      '--era-bg-secondary': '#111111',
      '--era-text-primary': '#33ff33',
      '--era-text-muted': '#1a9c1a',
      '--era-accent': '#33ff33',
      '--era-accent-bg': 'rgba(51, 255, 51, 0.1)',
      '--era-link-color': '#33ff33',
      '--era-font-heading': "'Courier New', 'Consolas', monospace",
      '--era-font-body': "'Courier New', 'Consolas', monospace",
      '--era-border-radius': '0px',
      '--era-card-bg': 'rgba(51, 255, 51, 0.05)',
      '--era-card-bg-hover': 'rgba(51, 255, 51, 0.1)',
      '--era-section-bar': '#1a9c1a',
      '--era-section-bar-active': '#33ff33',
      '--era-transition': '0ms',
    },
    features: {
      scanlines: true,
      blinkingCursor: true,
      typewriter: true,
      crtFlicker: true,
    },
  },
};

export const defaultEra = 'modern';
export const eraOrder = ['80s', '2000s', 'modern']; // Display order in timeline
